import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

export interface IApiResultObject {
    status: boolean;
    message: string;
    data: any;
    data2: any;
    code: number;
}

@Injectable()
export class ApiDataService {

    private corsHeaders: HttpHeaders;

    constructor(private http: HttpClient) {
        this.corsHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
        })
    }

    public Post(url: string, body: any) {
        return this.http.post(url, body, {
            headers: this.corsHeaders, withCredentials: true
        });
    }

    public Get(url: string) {
        return this.http.get(url, {
            headers: this.corsHeaders, withCredentials: true
        });
    }

    public PostCors(url: string, body: any) {
        return this.http.post(url, body, {
            headers: this.corsHeaders, withCredentials: false
        });
    }

    public GetCors(url: string) {
        return this.http.get(url, {
            headers: this.corsHeaders, withCredentials: false
        });
    }

    public PostAnonymous(url: string, body: any) {
        return this.http.post(url, body);
    }

    public GetAnonymous(url: string) {
        return this.http.get(url);
    }

    
}